/* eslint-disable no-console */
import React, { Component } from "react";
import { NavLink, withRouter } from "react-router-dom";
import { Route, Switch, Redirect } from "react-router-dom";
import PrivateRoute from "../../components/Routes/PrivateRoute";
import Auth from '../../actions/authActions';
import logo from "../../assets/img/panel_log_51all-small.jpg";
import Button from "../../components/CustomButton/CustomButton.jsx";

import dashboardRoutes from "../../routes/dashboard.jsx";


class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth
    };
    this.handleLoginLogout = this.handleLoginLogout.bind(this);
  }
  activeRoute(routeName) {
    //console.log(`routeName: ${routeName}`);
    //console.log(`location: ${this.props.location}`);

    // return dashboardRoutes.map((prop, key) => {
    //   return prop.location.indexOf(routeName) > -1 ? "active" : "";
    // })
    if (this.props.location)
      return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
    else
      return "";
  }
  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }
  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  handleLoginLogout(e) {
    e.preventDefault();
    localStorage.removeItem('isAuthenticated');
    this.props.history.push('login');
  }

  render() {
    // const sidebarBackground = {
    //   backgroundImage: "url(" + imagine + ")"
    // };
    // const activeStyle = { color: 'red' };
    return (

      <div
        id="sidebar"
        className="sidebar"
      // data-color="black"
      // data-image={imagine}
      >
        {/* <div className="sidebar-background" style={sidebarBackground} /> */}
        <div className="sidebar-background" />
        <div className="logo">
          <a
            href="#"
            className="simple-text logo-mini"
          >
            <div className="logo-img">
              <img src={logo} alt="logo_image" />
              <div style={{ marginLeft: 20 + "px" }}>ELLVIS 9000 Series</div>
            </div>
          </a>

        </div>
        <div className="sidebar-wrapper">
          <ul className="nav">
            {/* {this.state.width <= 991 ? <HeaderLinks /> : null} */}

            {dashboardRoutes.map((prop, key) => {
              let loginUrl = (prop.name === "Login" && localStorage.getItem('isAuthenticated')) ? "/logout" : prop.path;
              if (!prop.redirect && prop.name)
                return (
                  <li
                    className={
                      prop.name === "Login"
                        ? "active active-pro"
                        : this.activeRoute(prop.path)
                    }
                    key={key}
                  >
                    {prop.private ?
                      <PrivateRoute {...prop} />
                      :
                      <Button onClick={this.handleLoginLogout} bsStyle="info" style={{ margin: 10 + "px", backgroundColor: "grey", color: "white", borderColor: "gray", width: 90 + "%" }} block>{prop.name === "Login" && localStorage.getItem('isAuthenticated') ? "Logout" : prop.name} </Button>}
                  </li>
                );

              return null;
            })}
          </ul>
        </div>
      </div>
    );
  }
}

export default withRouter(Sidebar);
